import { createContext, useContext } from 'react';
const ApiV2ModelContext = createContext(undefined);
export const useApiV2ModelContext = () => {
    const context = useContext(ApiV2ModelContext);
    if (context === undefined) {
        throw new Error('useApiV2ModelContext must be used within a ApiV2ModelProvider');
    }
    return context;
};
export default ApiV2ModelContext;
